import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem('session_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Hook to fetch the user's free-tier usage limits.
 *
 * Returns:
 *  - limits: full response from /api/usage/limits (or null while loading)
 *  - refresh(): re-fetch (call after a successful generation)
 *  - isLocked(category): boolean — true if user is free-tier AND that category is capped
 */
export default function useUsageLimits() {
  const [limits, setLimits] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/api/usage/limits`, { headers: getAuthHeaders() });
      setLimits(response.data);
    } catch (err) {
      // Silent fail — UI will just not show usage indicator
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const isLocked = useCallback(
    (category) => !!(limits && limits[category] && limits[category].limit_reached),
    [limits]
  );

  return { limits, refresh, isLocked };
}
